import { connect } from 'react-redux';
import { findHotels, selectHotel, favoriteHotel, selectHotelFromWeb,requestBidsets } from '../modules/tour';

import HotelAddDetail from './HotelAddDetail';
import { requestHotelAdvanceSearch, requestHotelAdvanceSearchWithPrefs,requestHotelByPlaces} from '../../hotels/modules/hotels';

const mapDispatchToProps = {
  findHotels,
  selectHotel,
  favoriteHotel,
  requestHotelAdvanceSearch,
  requestHotelAdvanceSearchWithPrefs,
  selectHotelFromWeb,
  requestHotelByPlaces,
  requestBidsets
};

const mapStateToProps = state => ({
  hotels: state.tours.findHotels.hotels,
  fetching: state.tours.findHotels.fetching,
  search: state.tours.findHotels.search,
});
const HotelAddDetailContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(HotelAddDetail);
export default HotelAddDetailContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelAddDetailContainer.js